import React, { useEffect, useState } from "react";
import "./Community.scss";
import { mobile } from "../Services/Agent";
import { GA_Push } from "../Services/GoogleAnalytics";

export default function Community({ community }) {
  const [cubeList, setCubeList] = useState();
  const [isBusy, setIsBusy] = useState();
  const [posted, setPosted] = useState(null);
  const [boxsticky, setSticky] = useState(null);
  const [email, setEmail] = useState("");

  useEffect(() => {
    var activeTrail = document.getElementById("activetrail");
    var footer = document.getElementsByTagName("footer")[0];
    window.onscroll = (event) => {
      if (
        window.innerHeight + window.scrollY + footer.clientHeight >=
          document.body.offsetHeight &&
        mobile()
      ) {
        activeTrail.style.bottom =
          Math.abs(
            document.body.offsetHeight -
              footer.clientHeight -
              window.scrollY -
              window.innerHeight
          ) + "px";
      } else if (mobile()) {
        activeTrail.style.bottom = 0;
      }
    };
  }, []);

  useEffect(() => {
    setSticky("");
  }, [community]);

  let communitiesDic = {
    family: 33773,
    env: 33793,
    nut: 33772,
  };

  let hebrewDic = {
    family: "משפחתי",
    env: "סביבתי",
    nut: "תזונתי",
  };

  let ATDic = {
    family: 12227,
    env: 12228,
    nut: 12229,
  };

  let groupDic = {
    family: 176965,
    env: 176966,
    nut: 176964,
  };
  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      // Validation checks out
      // BL
      if (document.querySelector("#tak").checked) {
        // console.log(email)
        cleanAgent();
        postData();
        // setEmail("");
        GA_Push(
          "Form_Events",
          "Form Sent",
          "Osem Balanced kitchen",
          "Lead Form"
        );
        return;
      }
      alert("אנא אשר את מדיניות הפרטיות וקבלת דיוורים ");
    } else {
      // email isnt valid
      alert("המייל שהוזן אינו תקין");
    }
  };

  const postData = () => {
    // console.log('go');
    var formData = new FormData();
    formData.append("email", email);
    formData.append("MailingList", ATDic[community]);
    formData.append("groups", groupDic[community]);

    fetch(
      `${window.location.origin}/mshort/content/api/ynetactivetrail/`,
      // `http://localhost:57202/`
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setPosted(community);
      })
      .catch((e) => {
        setPosted(community);
      });
  };

  useEffect(() => {
    if (isBusy) return;
    try {
      setIsBusy(true);
      setCubeList();
      fetch(
        `https://z.ynet.co.il/mShort/content/API/YnetChannel/?id=${communitiesDic[community]}`
      )
        .then((res) => res.json())
        .then((data) => {
          setCubeList(data.components[0].items);
          setIsBusy(false);
        });
    } catch (err) {
      setIsBusy(false);
      console.log(err);
    }
  }, [community]);

  function handleChange(e) {
    setEmail(e.target.value);
  }

  function cleanAgent() {
    // document.querySelector(".a_subtitle").innerHTML = `הרשמתך התקבלה. \n
    // <div class="tnx">העדכונים החמים בדרך אליכם!</div>`
    // document.querySelector(".a_subtitle").style.fontSize = mobile() ? "6vw" : "27px"
    // document.querySelector(".a_subtitle").style.fontFamily = "Open Sans Hebrew Bold"
    // document.querySelector(".check_wrapper").style.visibility = "hidden"
    // document.querySelector("#email").style.visibility = "hidden"
    // document.querySelector(".after").style.visibility = "hidden"
    // document.querySelector(".a_title").style.visibility = "hidden"
  }

  function titleSaw(title) {
    let titleArr = title.split(" ");
    titleArr.length = mobile() ? 4 : 6;
    return titleArr.join(" ");
  }

  function subtitleSaw(title) {
    let titleArr = [];
    titleArr = title.split(" ");
    let maxLength = mobile() ? 10 : 17;
    let originalLength = titleArr.length;
    //titleArr.length = mobile() ? 12 : 24;
    titleArr.length = maxLength;

    if (
      titleArr[titleArr.length - 1].endsWith(",") ||
      titleArr[titleArr.length - 1].endsWith("?")
    ) {
      let lastWordLen = titleArr[titleArr.length - 1].length;
      titleArr[titleArr.length - 1] = titleArr[titleArr.length - 1].substring(
        0,
        lastWordLen - 1
      );
    }
    if (originalLength > maxLength) {
      titleArr[titleArr.length - 1] += "...";
    }
    return titleArr.join(" ");
  }
  function handleClick() {
    setSticky(community);
    // document.querySelector(".active_trail").style.display = "none"
  }
  return (
    <div className="com">
      <div className="story_container">
        {cubeList ? (
          cubeList.map((c) => (
            <div
              key={c.link_data.id}
              className="cube"
              onClick={() => {
                window.location.href = c.link_data.href;
              }}
            >
              <img src={`${c.img_data.src}`} className="img" alt="Article" />
              <div className="text_wrapper">
                <div className="title">{titleSaw(c.title)}</div>
                <div className="desc">{subtitleSaw(c.sub_title)} </div>
                <a
                  href={`${c.link_data.href}`}
                  className="readmore"
                  target="_blank"
                >
                  המשך קריאה
                </a>
              </div>
            </div>
          ))
        ) : (
          <h1 className="loader"></h1>
        )}
        {/* <div className="spacer"></div> */}
      </div>
      {/* <div className="active-trail-container"> */}
      <div
        id="activetrail"
        className={`active_trail ${community} ${
          posted == community && "thanks"
        }`}
        style={
          boxsticky == community
            ? {
                display: "none",
              }
            : {}
        }
      >
        <div className="x" onClick={handleClick}>
          x
        </div>
        <div className="a_title">מחפשים עוד איזון {hebrewDic[community]}?</div>
        <div className="a_subtitle end">
          הרשמתך התקבלה. <br />
          <div class="tnx">העדכונים החמים בדרך אליכם!</div>
        </div>
        <div className="a_subtitle">
          הרשמו לניוזלטר של איזון
          {<span> {hebrewDic[community]}</span>}
          ותקבלו מאיתנו עוד כתבות מעניינות
        </div>
        <div className="check_wrapper">
          <label htmlFor="tak">
            בעת הרשמתי אני מסכים למסירת הפרטים למאגר הצרכנים של קבוצת אסם, בהתאם
            ל
            <a
              target="_blank"
              href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html"
            >
              מדיניות הפרטיות
            </a>
            , ולקבלת הטבות, מבצעים ועדכונים מ'אסם' ו/או מחברות 'קבוצת אסם':
            נסטלה, נסקפה, מטרנה, צבר, בונזו'ר, ויטמינצ'יק, סטארבקס, קיטקט,
            סמארטיס, בישולים ופורינה, בכל אחד מערוצי התקשורת.
          </label>
          <input type="checkbox" name="tak" id="tak" />
        </div>
        <input
          type="email"
          value={email}
          id="email"
          placeholder='דוא"ל'
          onChange={(e) => handleChange(e)}
        />
        <div className="after" onClick={validateEmail}></div>
      </div>
      {/* </div> */}
    </div>
  );
}
